window.GA_VARIABLES = {
    debug: false,

    click: [
       /* {
            selector: '.ap_heder-contact-link',
            eventCategory: 'click_tel',
            eventAction: 'header',
            eventLabel: '$page_url',
        },*/

    ],

    submit: [
        /*{
            selector: '#gform_2',
            eventCategory: 'generate_lead',
        },*/
    ],

    ajaxSuccess: [
        /*{
            formId: 1,
            eventCategory: 'generate_lead',
        },*/
    ],
};


// WEBPACK FOOTER //
// ./_project/scripts/ga/ga-variables.js